import React from 'react';

import WpIcon from 'Wpds/components/icon/WpIcon';
import { sanitizeFullName } from 'Shared/helpers';

import './GoalDropdown.scss';

type Props = {
  readonly goalIcon: string;
  readonly goalName: string;
  readonly goalOwner: string;
};

function GoalDropdown({ goalIcon, goalName, goalOwner }: Props) {
  const baseClassName = 'GoalDropdown';
  return (
    <div className={`${baseClassName} d-flex flex-column`}>
      <div className={`${baseClassName}__header d-flex justify-content-between align-items-center p-2`}>
        <div className="d-flex align-items-center flex-nowrap">
          <WpIcon name={goalIcon} />
          <div className="ml-1">Goal</div>
        </div>
        <div className={`${baseClassName}__header_owner`}>Owner: {sanitizeFullName(goalOwner)}</div>
      </div>
      <div className={`${baseClassName}__content px-2`}>
        <div className={`${baseClassName}__content__name`}>{goalName}</div>
      </div>
    </div>
  );
}

export default GoalDropdown;
